export default __webpack_public_path__ + "static/media/white-4.7f4959ef.png";